import Actions from '@/constants/action'
import { http } from '@/api'
import { Account, Event, PublicEvent, Apply } from '@/api/collection'
import {
  getAliyunPulicOSSPostAuthorization,
  getAliyunPrivateOSSPostAuthorization,
  getAliyunOSSDownloadAuthorization,
  uploadFile,
  uploadFileToSys
} from '@/api/file'
import getConfig from '@/config/index'

export default {
  [Actions.SET_LANGUAGE]({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  [Actions.UPDATE_USER_LOCAL_INFO]({ commit }, info) {
    commit('UPDATE_USER_LOCAL_INFO', info)
  },

  // Account
  async [Actions.GET_VERIFY_CODE]({ commit }, payload) {
    try {
      commit('UPDATE_LOADING', { verifyCodeLoading: true })
      await http({
        path: Account.GetSMSVerificationCode.path,
        method: Account.GetSMSVerificationCode.method, data: payload
      })
    } finally {
      commit('UPDATE_LOADING', { verifyCodeLoading: false })
    }
  },
  async [Actions.LOGIN]({ commit, state }, payload) {
    commit('UPDATE_LOADING', { userInfoLoading: true })
    commit('UPDATE_EVENT_CAMPAIGN_ID', payload.campaignId)
    try {
      const res = await http(
        {
          path: Account.Login.path,
          method: Account.Login.method,
          data: payload
        }
      )
      commit('UPDATE_USER_LOCAL_INFO', Object.assign({}, state.userInfo,
        {
          token: res.tokens.token,
          refreshToken: res.tokens.refreshToken,
          leadId: res.tokens.leadId,
          leadRegisterStatus: res.leadRegisterStatus,
          phone: payload.phoneNo
        },
        res.leadBaseInfo,
      ))
      return res
    } finally {
      commit('UPDATE_LOADING', { userInfoLoading: false })
    }
  },
  async [Actions.SIMPLE_LOGIN]({ commit, state }, payload) {
    commit('UPDATE_LOADING', { userInfoLoading: true })
    commit('UPDATE_LOADING', { saveNewSurveyAnswerLoading: true })
    try {
      const res = await http(
        {
          path: Account.SimpleLogin.path,
          method: Account.SimpleLogin.method,
          data: payload
        }
      )
      commit('UPDATE_SIMPLE_USER_INFO', Object.assign({}, state.userInfo,
        payload,
        {
          token: res.tokens.token,
          refreshToken: res.tokens.refreshToken,
          leadId: res.tokens.leadId,
          campaignId: res.campaignId
        }
      ))
      return res
    } finally {
      commit('UPDATE_LOADING', { userInfoLoading: false })
      commit('UPDATE_LOADING', { saveNewSurveyAnswerLoading: false })
    }
  },
  async [Actions.ALUMNI_LOGIN]({ commit, state }, payload) {
    commit('UPDATE_LOADING', { userInfoLoading: true })
    try {
      const res = await http(
        {
          path: Account.AlumniLogin.path,
          method: Account.AlumniLogin.method,
          data: payload
        }
      )
      commit('UPDATE_SIMPLE_USER_INFO', Object.assign({}, state.userInfo,
        {
          token: res.tokens.token,
          refreshToken: res.tokens.refreshToken,
          leadId: res.tokens.leadId
        },
        payload
      ))
      return res
    } finally {
      commit('UPDATE_LOADING', { userInfoLoading: false })
    }
  },
  async [Actions.REALLY_ALUMNI_LOGIN]({ commit, state }, payload) {
    commit('UPDATE_LOADING', { userInfoLoading: true })
    try {
      const res = await http(
        {
          path: Account.ReallyAlumniLogin.path,
          method: Account.ReallyAlumniLogin.method,
          data: payload
        }
      )
      commit('UPDATE_SIMPLE_USER_INFO', Object.assign({}, state.userInfo,
        {
          token: res.tokens.token,
          refreshToken: res.tokens.refreshToken,
          leadId: res.tokens.leadId
        },
        payload
      ))
      return res
    } finally {
      commit('UPDATE_LOADING', { userInfoLoading: false })
    }
  },
  async [Actions.GET_BASE_INFO]({ commit, state }, payload) {
    commit('UPDATE_LOADING', { userInfoLoading: true })
    try {
      const res = await http(
        {
          path: Account.GetBaseInfo.path,
          method: Account.GetBaseInfo.method,
          data: payload
        }
      )
      commit('UPDATE_USER_LOCAL_INFO', Object.assign({}, state.userInfo,
        {
          leadRegisterStatus: res.leadRegisterStatus
        },
        res.leadBaseInfo,
      ))

      return res
    } finally {
      commit('UPDATE_LOADING', { userInfoLoading: false })
    }
  },
  async [Actions.LOGOUT]({ commit, state }) {
    try{
      const res = await http({
        path: Account.RevokeToken.path,
        method: Account.RevokeToken.method,
      })
      commit('EMPTY_USER_LOCAL_INFO')
      return res
    } finally {
      // Nothing to do
    }
  },
  async [Actions.UPDATE_USER_INFO]({ commit }, payload) {
    commit('UPDATE_LOADING', { userInfoLoading: true })
    try {
      const res = await http(
        {
          path: Account.UpdateBaseInfo.path,
          method: Account.UpdateBaseInfo.method,
          data: payload
        }
      )
      commit('UPDATE_USER_LOCAL_INFO', payload)
      return res
    } finally {
      commit('UPDATE_LOADING', { userInfoLoading: false })
    }
  },
  async [Actions.UPDATE_AVATAR]({ commit, dispatch }, payload) {
    const res = await http(
      {
        path: Account.UpdatePortrait.path,
        method: Account.UpdatePortrait.method,
        data: payload
      }
    )
    await dispatch(Actions.GET_BASE_INFO, {})
    return res
  },
  async [Actions.UPDATE_RESUME]({ commit, dispatch }, payload) {
    const res = await http(
      {
        path: Account.UpdateResume.path,
        method: Account.UpdateResume.method,
        data: payload
      }
    )
    await dispatch(Actions.GET_BASE_INFO, {})
    return res
  },
  async [Actions.REFRESH_TOKEN]({ commit, state, dispatch }) {
    if (state.loading.tokenRefreshing) {
      return
    }
    commit('UPDATE_LOADING', { tokenRefreshing: true })
    try {
      const res = await http(
        {
          path: Account.RefreshToken.path,
          method: Account.RefreshToken.method,
          data: {
            token: state.userInfo.token,
            refreshToken: state.userInfo.refreshToken
          }
        }
      )
      commit('UPDATE_USER_LOCAL_INFO', Object.assign({}, state.userInfo,
        {
          token: res.data.token,
          refreshToken: res.data.refreshToken
        }
      ))

      return res
    } catch (err) {
      // await dispatch(Actions.LOGOUT)
      commit('EMPTY_USER_LOCAL_INFO')
    } finally {
      commit('UPDATE_LOADING', { tokenRefreshing: false })
      location.reload()
    }
  },
  async [Actions.SAVE_SURVEY]({ commit, state }, payload) {
    commit('UPDATE_LOADING', { saveSurveyLoading: true })
    try {
      const res = await http(
        {
          path: Account.SaveSurvey.path,
          method: Account.SaveSurvey.method,
          data: payload
        }
      )

      return res
    } finally {
      commit('UPDATE_LOADING', { saveSurveyLoading: false })
    }
  },
  async [Actions.SAVE_NEW_SURVEY_ANSWER]({ commit, state }, payload) {
    try {
      const res = await http(
        {
          path: PublicEvent.SaveNewSurveyAnswer.path,
          method: PublicEvent.SaveNewSurveyAnswer.method,
          data: payload
        }
      )
      return res
    } finally {
      commit('UPDATE_LOADING', { saveNewSurveyAnswerLoading: false })
    }
  },
  async [Actions.SAVE_ANONYMOUS_SURVEY_ANSWER]({ commit, state }, payload) {
    try {
      commit('UPDATE_LOADING', { saveAnonymousSurveyAnswerLoading: true })
      const res = await http(
        {
          path: PublicEvent.SaveAnonymousSurveyAnswer.path,
          method: PublicEvent.SaveAnonymousSurveyAnswer.method,
          data: payload
        }
      )
      if (res.resultCode === '0') {
        commit('UPDATE_SIMPLE_USER_INFO', Object.assign({}, state.userInfo,
          {
            token: res.tokens.token,
            refreshToken: res.tokens.refreshToken,
            leadId: res.tokens.leadId
          }
        ))
      }
      return res
    } finally {
      commit('UPDATE_LOADING', { saveAnonymousSurveyAnswerLoading: false })
    }
  },
  async [Actions.CHECK_USER_EXIST]({ commit, state }, payload) {
    commit('UPDATE_LOADING', { checkUserExistLoading: true })
    try {
      const res = await http(
        {
          path: Account.CheckUserExist.path,
          method: Account.CheckUserExist.method,
          data: payload
        }
      )

      return res
    } finally {
      commit('UPDATE_LOADING', { checkUserExistLoading: false })
    }
  },
  // Events
  async [Actions.GET_TOP_EVENTS]({ commit, state }, payload) {
    if (state.eventList.length > 0) {
      return state.eventList
    }
    commit('UPDATE_LOADING', { eventListLoading: true })
    try {
      const res = await http(
        {
          path: Event.GetTopTenEvents.path,
          method: Event.GetTopTenEvents.method,
          data: payload
        }
      )
      commit('UPDATE_TOP_EVENT_LIST', res.data)
      return res
    } finally {
      commit('UPDATE_LOADING', { eventListLoading: false })
    }
  },
  async [Actions.GET_EVENT_BY_ID]({ commit, state }, payload) {
    // const event = state.eventList.find(v => v.id === payload.id)
    // if (event) {
    //   return event
    // }
    try {
      commit('UPDATE_LOADING', { eventLoading: true })
      const res = await http(
        {
          path: Event.GetEventById.path,
          method: Event.GetEventById.method,
          data: payload
        }
      )
      return res.data
    } finally {
      commit('UPDATE_LOADING', { eventLoading: false })
    }
  },
  async [Actions.GET_REGISTED_EVENTS]({ commit, state }, payload) {
    commit('UPDATE_LOADING', { registeredEventsLoading: true })
    try {
      const res = await http(
        {
          path: Event.GetRegistedEvents.path,
          method: Event.GetRegistedEvents.method,
          data: payload
        }
      )
      commit('UPDATE_REGITERED_EVENTS', res.data)
      return res.data
    } finally {
      commit('UPDATE_LOADING', { registeredEventsLoading: false })
    }
  },
  async [Actions.GET_APPROVED_EVENTS]({ commit }, payload) {
    commit('UPDATE_LOADING', { approvedEventLoading: true })
    try {
      const res = await http(
        {
          path: Event.GetApprovedRegistedEvents.path,
          method: Event.GetApprovedRegistedEvents.method,
          data: payload
        }
      )
      commit('UPDATE_APPROVED_EVENTS', res.data)
      return res.data
    } finally {
      commit('UPDATE_LOADING', { approvedEventLoading: false })
    }
  },
  async [Actions.REGISTER_EVENT]({ commit, dispatch, state }, payload) {
    commit('UPDATE_LOADING', { registerEventLoading: true })
    try {
      const res = await http(
        {
          path: Event.LeadRegisterEvent.path,
          method: Event.LeadRegisterEvent.method,
          data: payload
        }
      )
      commit('UPDATE_USER_LOCAL_INFO', { eventId: payload.item })
      await dispatch(Actions.GET_REGISTED_EVENTS, {})
      await dispatch(Actions.GET_APPROVED_EVENTS, {})
      return res
    } finally {
      commit('UPDATE_LOADING', { registerEventLoading: false })
    }
  },
  async [Actions.GET_EVENTS_BY_CODE]({ commit, state }, payload) {
    commit('UPDATE_LOADING', { eventLoading: true })
    try {
      const res = await http(
        {
          path: Event.GetEventsByCode.path,
          method: Event.GetEventsByCode.method,
          data: payload
        }
      )
      if (res.data.length > 0) {
        commit('UPDATE_EVENT_CAMPAIGN_ID', res.campaignId)
        return Object.assign({}, res.data[0], {
          campaignId: res.campaignId
        })
      }
      return {}
    } finally {
      commit('UPDATE_LOADING', { eventLoading: false })
    }
  },
  async [Actions.GET_CAMPAIGN_ID_BY_CODE]({ commit }, payload) {
    commit('UPDATE_LOADING', { campaignIdLoading: true })
    try {
      const res = await http(
        {
          path: Event.GetCampaignIdByCode.path,
          method: Event.GetCampaignIdByCode.method,
          data: payload
        }
      )
      return res
    } finally {
      commit('UPDATE_LOADING', { campaignIdLoading: false })
    }
  },
  // Public Events
  async [Actions.GET_LOOKUP]({ commit }, payload) {
    commit('UPDATE_LOADING', { lookupLoading: true })
    try {
      const res = await http(
        {
          path: PublicEvent.GetLookups.path,
          method: PublicEvent.GetLookups.method,
          data: payload
        }
      )
      commit('UPDATE_LOOKUPS', res.data)
      return res.data
    } finally {
      commit('UPDATE_LOADING', { lookupLoading: false })
    }
  },

  // File
  async [Actions.UPLOAD_FILE]({ commit, state }, payload) {
    try {
      return await upload(state, commit, payload)
    } catch (err) {
      throw err
    }
  },

  async [Actions.UPLOAD_FILE_TO_SYS]({ commit, state }, payload) {
    try {
      return await uploadFileSys(payload)
    } catch (err) {
      throw err
    }
  },

  async [Actions.FETCH_FILE_URL]({ state }, payload) {
    return await getAliyunOSSDownloadAuthorization({
      fileName: payload
    })
  },
  async [Actions.SAVE_TEMP_FILES]({ commit, state }, payload) {
    commit('SET_TEMP_FILES', payload)
  },
  async [Actions.SAVE_TEMP_SURVEY]({ commit, state }, payload) {
    commit('SET_TEMP_SURVEY', payload)
  },
  // Apply
  async [Actions.GET_APPLY_LOOKUPS]({ commit, state }, payload) {
    commit('UPDATE_LOADING', { applyLookupLoading: true })
    try {
      const res = await http(
        {
          path: Apply.GetLookups.path,
          method: Apply.GetLookups.method,
          data: payload
        }
      )
      commit('UPDATE_APPLY_LOOKUPS', res.data)
      return res.data
    } finally {
      commit('UPDATE_LOADING', { applyLookupLoading: false })
    }
  },
  async [Actions.GET_ANCHOR_APPLICATION_FORM]({ commit, state }, payload) {
    commit('UPDATE_LOADING', { anchorFormLoading: true })
    try {
      const res = await http(
        {
          path: Apply.GetAnchorApplicationForm.path,
          method: Apply.GetAnchorApplicationForm.method,
          data: payload
        }
      )
      commit('UPDATE_ANCHOR_FORM', res.data)
      return res.data
    } finally {
      commit('UPDATE_LOADING', { anchorFormLoading: false })
    }
  },
  async [Actions.SAVE_ANCHOR_APPLICATION]({ commit, state, dispatch }, payload) {
    commit('UPDATE_LOADING', { anchorFormLoading: true })
    try {
      const res = await http(
        {
          path: Apply.SaveAnchorApplication.path,
          method: Apply.SaveAnchorApplication.method,
          data: payload
        }
      )
      await dispatch(Actions.GET_ANCHOR_APPLICATION_FORM, {
        productId: payload.productId,
        campaignCode: payload.campaignCode
      })
      await dispatch(Actions.GET_BASE_INFO, {})
      return res
    } finally {
      commit('UPDATE_LOADING', { anchorFormLoading: false })
    }
  },
  async [Actions.SUBMIT_ANCHOR_APPLICATION]({ commit, dispatch, state }, payload) {
    commit('UPDATE_LOADING', { anchorFormLoading: true })
    try {
      const res = await http(
        {
          path: Apply.SubmitAnchorApplication.path,
          method: Apply.SubmitAnchorApplication.method,
          data: payload
        }
      )
      await dispatch(Actions.GET_ANCHOR_APPLICATION_FORM, {
        productId: payload.productId,
        campaignCode: payload.campaignCode
      })
      await dispatch(Actions.GET_BASE_INFO, {})
      return res
    } finally {
      commit('UPDATE_LOADING', { anchorFormLoading: false })
    }
  },
  async [Actions.GET_VIDEO_LIST]({ commit, state }, payload) {
    const res = await http(
      {
        path: PublicEvent.GetVideoList.path,
        method: PublicEvent.GetVideoList.method,
        data: payload
      }
    )
    return res
  },
  async [Actions.SAVE_VIDEO]({ commit, state }, payload) {
    commit('SAVE_VIDEO', payload)
  },
  async [Actions.VALIDATE_VIDEO_CODE]({ commit, state }, payload) {
    try {
      commit('UPDATE_LOADING', { submitBtnLoading: true })
      const res = await http(
        {
          path: PublicEvent.ValidateVideoCode.path,
          method: PublicEvent.ValidateVideoCode.method,
          data: payload
        }
      )
      return res
    } finally {
      commit('UPDATE_LOADING', { submitBtnLoading: false })
    }
  }
}
// 真实的上传 to oss
async function upload(state, commit, payload) {
  const { dir, isPublic } = payload
  let uploadAuthInfo = null

  let fullpath = `${dir}/${payload.name}`
  if (!dir) {
    fullpath = payload.name
  }
  // use fullpath as key, becasue bakend need verify file type and
  // if key is directory, bakend can not control what type of file uploaded
  // NOTE: It doesn't not fully avoid the problem
  if (isPublic) {
    uploadAuthInfo = await getAliyunPulicOSSPostAuthorization({ fileName: fullpath })
  } else {
    uploadAuthInfo = await getAliyunPrivateOSSPostAuthorization({ fileName: fullpath })
  }

  const formData = new FormData()
  formData.append('key', uploadAuthInfo.data.dir)
  formData.append('policy', uploadAuthInfo.data.policy)
  formData.append('OSSAccessKeyId', uploadAuthInfo.data.accessid)
  formData.append('success_action_status', 200)
  formData.append('signature', uploadAuthInfo.data.signature)
  formData.append('file', payload.file)
  const res = await uploadFile(uploadAuthInfo.data.host, formData)
  if (res.status !== 200) {
    return 'error'
  } else {
    if (isPublic) {
      return `${getConfig().PUBLIC_URL}/${dir}/${payload.name}`
    } else {
      // only for application
      return `${uploadAuthInfo.data.dir}`
    }
  }
}
/**
 * 上传一个或多个文件到系统后台
 * @param {文件组} fileList
 */
async function uploadFileSys(fileList) {
  const formData = new FormData()
  if (fileList.length > 0) {
    fileList.forEach(file => {
      formData.append('formFiles', file)
    })
  }
  return await uploadFileToSys(formData)
}
